"use strict";

exports.__esModule = true;
exports.PlantGridElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FlexGrid = require("../../Core/FlexGrid/FlexGrid");
var _Core = require("../../Core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _PlantListContext = require("../../Plant/PlantListContext");
var _ProfileContext = require("../../Profile/ProfileContext");
var _RestAPI = require("../../API/RestAPI");
var _PlantGridElementProps = require("./PlantGridElementProps");
var _PlantGridElementLayout = require("./PlantGridElementLayout");
var _constants = require("./constants");
var _API = require("../../API");
var _excluded = ["plant", "x", "y", "width", "height"];
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _PlantGridElement;
/* eslint-disable jsx-a11y/anchor-is-valid */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PlantGridElementContainer = _styledComponents["default"].article.withConfig({
  displayName: "PlantGridElement__PlantGridElementContainer",
  componentId: "sc-1799yr3-0"
})(["position:absolute;outline:solid 1px rgba(0,0,0,0.2);"]);

/**
 * Displays a virtualized grid of devices, repeating the supplied
 * element children for each device.
 */
var PlantGridElement = exports.PlantGridElement = (_dec = _ConfigurableLayout.LayoutSettingsContext.withContext, _dec2 = _Core.SelectionContext.withContext, _dec3 = _ReportingPeriod.ReportingPeriodContext.withContext, _dec4 = _ProfileContext.ProfileContext.withContext, _dec5 = _RestAPI.RestAPIContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_PlantGridElement = /*#__PURE__*/function (_Component) {
  function PlantGridElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.getPlants = function (plantList) {
      return plantList ? plantList : [];
    };
    _this.renderPlant = function (_ref) {
      var plant = _ref.plant,
        x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height,
        extra = _objectWithoutPropertiesLoose(_ref, _excluded);
      var _this$props = _this.props,
        children = _this$props.children,
        render = _this$props.render,
        itemBackgroundColor = _this$props.itemBackgroundColor,
        itemBorderColor = _this$props.itemBorderColor,
        api = _this$props.api;
      var transform = "translate3d(" + (x + 1) + "px, " + (y + 1) + "px, 0)";
      var style = {
        transform: transform,
        width: width - 2,
        height: height - 2,
        outlineColor: itemBorderColor,
        backgroundColor: itemBackgroundColor || "inherit"
      };
      var body = _react["default"].Children.map(render(children), function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, Object.assign({
          width: width - 2,
          height: (0, _constants.getHeight)(height)
        }, extra));
      });
      return /*#__PURE__*/_react["default"].createElement(PlantGridElementContainer, {
        key: plant.name,
        style: style,
        "data-testid": "PlantGrid.ElementContainer." + plant.name
      }, /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
        load: function load() {
          return api.get("/api/v1/plant/device", plant.name);
        }
      }, function (_ref2) {
        var devices = _ref2.data;
        return api.plantName === plant.name ? /*#__PURE__*/_react["default"].createElement(_PlantGridElementLayout.PlantGridElementLayout, {
          devices: devices,
          plant: plant,
          body: body
        }) : /*#__PURE__*/_react["default"].createElement(_API.APIProvider, {
          plantName: plant.name
        }, /*#__PURE__*/_react["default"].createElement(_PlantGridElementLayout.PlantGridElementLayout, {
          devices: devices,
          plant: plant,
          body: body
        }));
      }));
    };
    return _this;
  }
  _inheritsLoose(PlantGridElement, _Component);
  var _proto = PlantGridElement.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      itemWidth = _this$props2.itemWidth,
      itemHeight = _this$props2.itemHeight,
      columnGutter = _this$props2.columnGutter,
      rowGutter = _this$props2.rowGutter;
    return /*#__PURE__*/_react["default"].createElement(_PlantListContext.PlantListLoader, null, function (plantListLoader) {
      if (plantListLoader.loaded && plantListLoader.data) {
        var plants = _this2.getPlants(plantListLoader.data);
        return /*#__PURE__*/_react["default"].createElement(_FlexGrid.FlexGrid, {
          width: width,
          height: height,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          columnGutter: columnGutter,
          rowGutter: rowGutter,
          itemCount: plants.length,
          plants: plants,
          renderItem: function renderItem(_ref3) {
            var index = _ref3.index;
            return /*#__PURE__*/_react["default"].createElement(_Core.DebouncedRender, {
              key: index,
              plant: plants[index]
            }, _this2.renderPlant);
          }
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    });
  };
  return PlantGridElement;
}(_react.Component), _PlantGridElement.defaultProps = {
  width: 1024,
  height: 768,
  itemBorderColor: "rgba(0, 0, 0, 0.2)",
  layoutSettings: undefined,
  selection: undefined,
  reportingPeriod: undefined,
  profile: undefined,
  api: undefined
}, _PlantGridElement)) || _class) || _class) || _class) || _class) || _class);